import { Modal } from "@circle-react-uikit/ModalV2";
import { MODAL_SIZES } from "@circle-react-uikit/ModalV2/ModalContent";

import { useFormRenderingContext } from "../contexts/FormRenderingContext";
import { FormContent } from "../FormContent";
import { useModalCookie } from "../hooks/useModalCookie";
import { ModalHeader } from "./ModalHeader";

interface FormModalUIKitProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const FormModalUIKit = ({ open, onOpenChange }: FormModalUIKitProps) => {
  const { form, index, initialFocusRef, formBackgroundColor, formTextColor } =
    useFormRenderingContext();
  const { suppressPopupForm } = useModalCookie();

  const handleClose = () => {
    suppressPopupForm();
    onOpenChange(false);
    // eslint-disable-next-line sonarjs/post-message -- Disabled for plugin version update. Fix when possible.
    window.parent.postMessage(
      { type: "resize", formUid: form.uid, formIndex: index, height: "0" },
      "*",
    );
  };

  return (
    <Modal
      isOpen={open}
      contentPortalId="form-modal-portal"
      initialFocus={initialFocusRef}
    >
      <Modal.Overlay onClick={handleClose} />
      <Modal.Content
        size={MODAL_SIZES.md}
        style={{ backgroundColor: formBackgroundColor }}
        id={`form-modal-${form.uid}`}
      >
        <style>
          {`#form-modal-${form.uid} #form-modal-close-button:hover {
                 background-color: ${formBackgroundColor};
               }
               #form-modal-${form.uid} h4,
               #form-modal-${form.uid} #form-modal-close-button svg {
                 color: ${formTextColor} !important;
               }`}
        </style>
        <ModalHeader handleClose={handleClose} />
        <Modal.Body className="px-8 !pt-0">
          <FormContent />
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};
